import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {GeneralService} from './../../../services/general.service';

@Injectable()
export class UserStatusService extends GeneralService {

   static STATUS_DELETED  = 0;
   static STATUS_INACTIVE = 1;
   static STATUS_ACTIVE   = 10;

   static AUTOMATIC_FALSE = '0';
   static AUTOMATIC_TRUE  = '1';

    constructor(protected http: HttpClient) {
        super(http);
    }

    getStatuses(): Array<{status: number, name: string}> {
        return [
          {status: UserStatusService.STATUS_DELETED,  name: 'Deleted'},
          {status: UserStatusService.STATUS_INACTIVE, name: 'Inactive'},
          {status: UserStatusService.STATUS_ACTIVE,   name: 'Active'},
        ]
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/user/user-status/user-status.service.ts